import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { forkJoin, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { BoltMaterialModel, FlangeMaterialModel, GasketModel, GasketTypeModel } from 'src/app/Modules/informate/models';
import { MaterialAliasModel, MaterialTypeModel } from 'src/app/Modules/settings/models';
import { DbSelectLookUpModel, DbSelectLookUpValue } from 'src/app/Modules/settings/models/idms/db-select-look-up.model';
import { IceapiService, IdmApiService, UserUtilityService } from 'src/app/services';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { DeleteDialogComponent } from 'src/app/shared/info-dialogs/delete-dialog/delete-dialog.component';
import { AddUpdateDBLookUpFieldComponent } from '../add-update-db-look-up-field/add-update-db-look-up-field.component';
import { MaterialListComponent } from '../material-list/material-list.component';
import { DxTreeListComponent } from 'devextreme-angular';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { IdmsSharedService } from 'src/app/Modules/idms/services/idms-shared.service';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';

@Component({
    selector: 'app-db-select-lookup-material-alias',
    templateUrl: './db-select-lookup-material-alias.component.html',
    styleUrls: ['./db-select-lookup-material-alias.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class DbSelectLookupMaterialAliasComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    @ViewChild('treeList', { static: false }) treeList!: DxTreeListComponent;
    @ViewChild('treeList2', { static: false }) treeList2!: DxTreeListComponent;

    destroy$ = new Subject();

    dbLookUpItems: DbSelectLookUpModel[];
    materialAliasTypes: MaterialTypeModel[];
    materialAliasList: MaterialAliasModel[];
    flangeMaterialList: FlangeMaterialModel[];
    boltMaterialList: BoltMaterialModel[];
    gasketTypesList: GasketTypeModel[];
    gasketsList: GasketModel[];
    materialType: string;
    selectedMaterial: string;
    isDbLookUpField: boolean;
    isDbLookUpAdd: boolean;
    isDbLookUpUpdate: boolean;
    isDbLookUpDelete: boolean;
    isMaterialAliasView: boolean;
    isMaterialAliasAdd: boolean;
    isMaterialALiasUpdate: boolean;
    isMaterialAliasDelete: boolean;
    dbLookUpApiPayload: DbSelectLookUpModel[];
    materialAliasApiPayload: MaterialAliasModel[];
    dbLookUpsFormArray: UntypedFormArray;
    selectedDbLookUpItems: DbSelectLookUpModel[] = [];
    dbLookUpItemsNew: DbSelectLookUpModel[] = [];

    rowIndex: number = 0;
    disableEdit = true;
    disableCancel = true;
    disableEditMaterialAlias = true;
    disableCancelMaterialAlias = true;
    finaldataForSave: DbSelectLookUpModel[] = [];
    finalMaterialAliasDataForSave: MaterialAliasModel[] = [];
    finalMaterialAliasDataForDelete: MaterialAliasModel[] = [];
    editedCells: { [key: number]: Set<string> } = {};
    materialAliasTypesList: any[] = [];
    savedData: any;
    isError: boolean = false;
    isValidData: boolean = false;
    storeddataforSave: DbSelectLookUpModel[] = [];
    isMultipleActions: Boolean = false;
    storeddataforSaveForMaterialAlias: MaterialAliasModel[] = [];
    isMultipleActionsForMaterialAlias: Boolean = false;
    isMaterialAliasUpdating: Boolean = false;
    isMaterialChanged: Boolean = false;
    selectedMaterialAliasModel: MaterialAliasModel[] = [];
    isDbSelectUpdating: Boolean = false;
    materialAlias: MaterialAliasModel = new MaterialAliasModel();

    constructor(
        private ngbModal: NgbModal,
        private iceApiService: IceapiService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private userUtilityService: UserUtilityService,
        private customToastService: CustomToastService,
        private globalEmitterService: GlobalEmittersService,
        private idmApiService: IdmApiService,
        private cd: ChangeDetectorRef,
        http: HttpClient,
        public dialog: MatDialog,
        private IdmsSharedService: IdmsSharedService,
        private customValidator: CustomValidatorService
    ) {
        this.isDbLookUpField = false;
        this.isDbLookUpAdd = false;
        this.isDbLookUpUpdate = false;
        this.isDbLookUpDelete = false;
        this.isMaterialAliasView = false;
        this.isMaterialAliasAdd = false;
        this.isMaterialALiasUpdate = false;
        this.isMaterialAliasDelete = false;
        this.materialAliasTypes = [];
        this.materialAliasList = [];
        this.dbLookUpItems = [];
        this.gasketsList = [];
        this.dbLookUpApiPayload = [];
        this.materialAliasApiPayload = [];
    }

    async ngOnInit(): Promise<void> {
        this.globalEmitterService.dbSelectLookUpSaveEvent.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) this.saveLookUpFieldChanges(false);
        });

        this.globalEmitterService.materialAliasSaveEvent.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) this.saveMaterialAliasChanges(false, null);
        });

        await this.initializePermissionChecks();

        this.globalEmitterService.currentMaterialAlias.pipe(takeUntil(this.destroy$)).subscribe(async (res: FlangeMaterialModel) => {
            if (res) {
                this.loadMaterialAlias(res);
            }
        });

        //this.checkIfEdited();
    }

    // * initialize permission checks
    async initializePermissionChecks(): Promise<void> {
        this.isDbLookUpField = await this.userUtilityService.checkUserPermissionDataAndRoute('viewDbLookUpField', userActions.View);
        if (this.isDbLookUpField) this.getDbSelectsByInstanceId();
        this.isDbLookUpAdd = await this.userUtilityService.checkUserPermissionDataAndRoute('createDbLookUpField', userActions.Create);
        this.isDbLookUpUpdate = await this.userUtilityService.checkUserPermissionDataAndRoute('modifyDbLookUpFiled', userActions.Edit);
        this.isDbLookUpDelete = await this.userUtilityService.checkUserPermissionDataAndRoute('deleteDbLookUpField', userActions.Delete);
        this.isMaterialAliasView = await this.userUtilityService.checkUserPermissionDataAndRoute('viewMaterialAlias', userActions.View);
        if (this.isMaterialAliasView) {
            this.getMaterialAliasTypes();
            this.ngxUiLoaderService.start();
            forkJoin([
                this.iceApiService.getFlangeMaterials(),
                this.iceApiService.getBoltMaterials(),
                this.iceApiService.getGasketTypesForIdmsSettings(),
            ]).subscribe(([flangeMaterial, boltMaterial, gasketList]) => {
                this.ngxUiLoaderService.stop();
                this.boltMaterialList = boltMaterial.response;
                this.flangeMaterialList = flangeMaterial.response;
                this.gasketsList = gasketList.response;
                this.getMaterialAliasListById();
                this.getGasketTypes();
            });
        }
        this.isMaterialAliasAdd = await this.userUtilityService.checkUserPermissionDataAndRoute('createMaterialAlias', userActions.Create);
        this.isMaterialAliasDelete = await this.userUtilityService.checkUserPermissionDataAndRoute('deleteMaterialAlias', userActions.Delete);
        this.isMaterialALiasUpdate = await this.userUtilityService.checkUserPermissionDataAndRoute('modifyMaterialAlias', userActions.Edit);
    }

    // * create form controls
    initializeFormControl(index: number): void {
        switch (index) {
            case 0:
                const dbLookUpFormArray = this.form.get('dbLookUpMaterialAlias') as UntypedFormArray;
                dbLookUpFormArray.clear();
                const CreateControl = (value?: DbSelectLookUpValue) => {
                    return new UntypedFormGroup({
                        databaseSelectValueId: new UntypedFormControl(value?.databaseSelectValueId, []),
                        name: new UntypedFormControl(value.name, [Validators.required]),
                        isSelected: new UntypedFormControl(false, []),
                    });
                };
                this.dbLookUpItems.forEach((item) => {
                    const formGroup = new UntypedFormGroup({
                        databaseSelectId: new UntypedFormControl(item?.databaseSelectId, []),
                        name: new UntypedFormControl(item?.name, [Validators.required]),
                        values: new UntypedFormArray([]),
                    });
                    const valuesFormArray = formGroup.get('values') as UntypedFormArray;
                    if (item?.values) {
                        item?.values.forEach((value) => {
                            valuesFormArray.push(CreateControl(value));
                        });
                    }

                    dbLookUpFormArray.push(formGroup);
                });

                break;

            case 1:
                break;
        }

        // this.materialAliasTypesList.forEach((x) => {
        //     if (x && x.materialType && x.materialType?.materialType) {
        //         x.qualifiedName = this.findQualifiedName(x.materialType?.materialType, x?.materialId);
        //     }
        // });
    }

    // * helper method to add new DB look up fields
    addNewDBLookUpField(): void {
        const dialogRef = this.ngbModal.open(AddUpdateDBLookUpFieldComponent, {
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
        });
        dialogRef.componentInstance.modalMode = 'add';
        dialogRef.componentInstance.dbSelectLookUpItemList = JSON.parse(JSON.stringify(this.dbLookUpItems.slice()));
        dialogRef.result
            .then((res: DbSelectLookUpModel[]) => {
                if (res) {
                    // TODO update the necessary properties
                    res.forEach((item) => {
                        let index = this.dbLookUpItems.findIndex((lookUp) => lookUp.name.toLowerCase().trim() == item.name.toLowerCase().trim());
                        const form = this.form.get('dbLookUpMaterialAlias') as UntypedFormArray;
                        if (index !== -1) {
                            // * if new db look up value added in existing db look up
                            const mainFormGroup = form.controls.find(
                                (control) => control.get('name').value.toLowerCase().trim() == item.name.toLowerCase().trim()
                            );
                            const subFormGroup = mainFormGroup.get('values') as UntypedFormArray;
                            // * creating the form controls
                            item.values.forEach((value) => {
                                subFormGroup.push(this.createFormControl(1, null, value));
                                subFormGroup.controls[subFormGroup.controls.length - 1].get('name').markAsDirty();
                            });
                            if (this.dbLookUpItems[index].values)
                                this.dbLookUpItems[index].values = [...this.dbLookUpItems[index].values, ...item.values]; // * updating the values array with newly created
                            else this.dbLookUpItems[index]['values'] = item.values; // * updating the values array with newly created
                            mainFormGroup.get('name').markAsDirty();
                        } else {
                            // * new db look up created
                            form.push(this.createFormControl(0, item, null));
                            const valuesFormGroup = form.controls[form.length - 1].get('values') as UntypedFormArray;
                            item.values.forEach((value) => {
                                valuesFormGroup.push(this.createFormControl(1, null, value));
                                valuesFormGroup.controls[valuesFormGroup.controls.length - 1].get('name').markAsDirty();
                            });
                            this.dbLookUpItems.push(item); // * updating the already existing data
                            form.controls[form.controls.length - 1].get('name').markAsDirty();
                        }
                    });

                    this.saveLookUpFieldChanges(false);

                    this.cd.detectChanges();
                }
            })
            .catch((err) => {
                console.warn(err);
            });
    }

    // * helper method to create form controls
    createFormControl(index: number, mainFormGroupValue?: DbSelectLookUpModel, subFormGroupValue?: DbSelectLookUpValue) {
        switch (index) {
            case 0: // * returns whole form group
                return new UntypedFormGroup({
                    name: new UntypedFormControl(mainFormGroupValue?.name, [Validators.required]),
                    values: new UntypedFormArray([]),
                });

            case 1: // * returns sub form group
                return new UntypedFormGroup({
                    name: new UntypedFormControl(subFormGroupValue?.name, [Validators.required]),
                    isSelected: new UntypedFormControl(false, []),
                });
        }
    }

    // * helper methods to edit the DB look Up field
    editDbLookUpField(lookUpItem: DbSelectLookUpModel, itemToEdit: DbSelectLookUpValue, mainFormGroup: UntypedFormGroup, subFormGroup: UntypedFormGroup): void {
        const editLookUpItem = this.selectedDbLookUpItems;

        const dialogRef = this.ngbModal.open(AddUpdateDBLookUpFieldComponent, {
            size: 'md',
            backdrop: 'static',
            keyboard: false,
        });

        dialogRef.componentInstance.dbSelectLookUpItem = editLookUpItem;
        dialogRef.componentInstance.modalMode = 'edit';
        dialogRef.componentInstance.dbSelectLookUpItemList = JSON.parse(JSON.stringify(this.dbLookUpItems.slice()));
        dialogRef.result
            .then((res) => {
                if (res) {
                    mainFormGroup.get('name').setValue(res.dbSelectName);
                    subFormGroup.get('name').setValue(res.dbSelectValueName);
                    mainFormGroup.get('name').markAsDirty();
                    subFormGroup.get('name').markAsDirty();
                    this.dbLookUpItems = this.form.get('dbLookUpMaterialAlias').value;
                    this.saveLookUpFieldChanges(false);
                    this.cd.markForCheck();
                }
            })
            .catch((err) => {
                console.warn(err);
            });
    }

    // * helper method to delete the DB look up field
    deleteDbLookUpsField(index: number): void {
        const dialogRef = this.ngbModal.open(DeleteDialogComponent, {
            size: 'sm',
            backdrop: 'static',
            keyboard: false,
        });

        if (index == 0) {
            dialogRef.componentInstance.modalMessage = 'Are you sure you want to delete selected <strong>DB lookups</strong>?';
            dialogRef.result
                .then((res) => {
                    if (res) {
                        this.componentHandler(1);
                    }
                })
                .catch((err) => {
                    console.warn(err);
                });
        } else {
            dialogRef.componentInstance.modalMessage = 'Are you sure you want to delete selected <strong>Material Alias</strong>?';
            dialogRef.result
                .then((res) => {
                    if (res) {
                        this.componentHandler(2);
                    }
                })
                .catch((err) => {
                    console.warn(err);
                });
        }
    }

    // * api call to save the lookUp field changes
    saveLookUpFieldChanges(isDelete: boolean, payload?: DbSelectLookUpModel[]): void {
        this.dbLookUpApiPayload = [];
        if (!isDelete) {
            this.componentHandler(7, null, null); // * generating api payload
        } else {
            this.dbLookUpApiPayload = payload;
        }
        const instanceId = localStorage.getItem('currentInstanceId');
        if (instanceId) {
            this.ngxUiLoaderService.start();
            this.idmApiService.saveDbSelectsChanges(instanceId, this.dbLookUpApiPayload).subscribe(
                (res) => {
                    this.ngxUiLoaderService.stop();
                    if (res.success) {
                        this.customToastService.successToast('Db look up fields saved successfully');

                        this.getDbSelectsByInstanceId();

                        // * removing the controls after deleting
                        if (isDelete) {
                            this.componentHandler(5, this.dbLookUpApiPayload); // * remove form controls
                            this.componentHandler(3, null, null); // * updating form
                            if (this.isMultipleActions) {
                                this.converttovaluelist(this.storeddataforSave);
                                this.isMultipleActions = false;
                                this.storeddataforSave = [];
                            } else {
                                this.getDbSelectsByInstanceId();
                            }
                        } else {
                            this.form.get('dbLookUpMaterialAlias').reset(this.form.get('dbLookUpMaterialAlias').value);
                            this.form.get('dbLookUpMaterialAlias').reset(this.form.get('dbLookUpMaterialAlias').value);
                            if (!this.isMultipleActions) {
                                this.getDbSelectsByInstanceId();
                            }
                        }
                    } else if (res.isCustom) {
                        this.userUtilityService.errorModelPopup(res.message);
                    }
                },
                (err) => this.ngxUiLoaderService.stop()
            );
        }
    }

    // * api call to save the changes of material Alias
    saveMaterialAliasChanges(isDelete: boolean, payload?: MaterialAliasModel[]): void {
        this.materialAliasApiPayload = [];
        const instanceId = localStorage.getItem('currentInstanceId');
        if (instanceId) {
            this.ngxUiLoaderService.start();
            this.idmApiService.saveMaterialAliasChanges(instanceId, payload).subscribe(
                (res) => {
                    this.ngxUiLoaderService.stop();
                    if (res.success) {
                        if (isDelete) {
                            this.componentHandler(6, null, payload); // * removing controls from material alias
                            this.componentHandler(4); // * updating material alias form state
                            this.customToastService.successToast('Material Alias deleted Successfully!');

                            if (this.isMultipleActionsForMaterialAlias) {
                                this.saveMaterialAlias(this.storeddataforSaveForMaterialAlias);
                                this.isMultipleActionsForMaterialAlias = false;
                                this.storeddataforSaveForMaterialAlias = [];
                            } else {
                                this.getMaterialAliasListById();
                            }

                            setTimeout(() => {
                                this.disableEditMaterialAlias = true;
                                this.disableCancelMaterialAlias = true;
                                this.cd.detectChanges();
                            }, 500);
                        } else {
                            if (this.isMultipleActionsForMaterialAlias) {
                                this.saveMaterialAlias(this.storeddataforSaveForMaterialAlias);
                                this.isMultipleActionsForMaterialAlias = false;
                                this.storeddataforSaveForMaterialAlias = [];
                            } else {
                                this.getMaterialAliasListById();
                            }

                            this.customToastService.successToast('Material Alias Changes Saved Successfully');
                        }
                    } else if (res.isCustom) {
                        this.userUtilityService.errorModelPopup(res.message);
                    }
                },
                (err) => this.ngxUiLoaderService.stop()
            );
        }
    }

    // * handle material alias type change
    materialTypeChange(index: number): void {
        const materialAliasFormArray = this.form.get('materialAlias') as UntypedFormArray;
        const currentFormGroup = materialAliasFormArray.controls[index];
        currentFormGroup.get('qualifiedName').reset();
        currentFormGroup.get('materialId').reset();
        currentFormGroup.get('alias').reset();
        this.materialAliasList[index].materialType = this.materialAliasTypes.find(
            (type) => type.materialTypeId == currentFormGroup.get('materialTypeId').value
        );
    }

    // * api call to get the db selects by instanceId
    getDbSelectsByInstanceId(): void {
        const instanceId = localStorage.getItem('currentInstanceId');
        if (instanceId) {
            this.ngxUiLoaderService.start();
            this.idmApiService.getDbSelectsByInstanceId(instanceId).subscribe(
                (res) => {
                    this.ngxUiLoaderService.stop();
                    if (res.success) {
                        this.dbLookUpItems = res.response;
                        this.mapDbselect(this.dbLookUpItems, '');
                        this.initializeFormControl(0);
                        this.cd.detectChanges();
                    } else if (res.isCustom) {
                        this.userUtilityService.errorModelPopup(res.message);
                    }
                },
                (err) => {
                    this.ngxUiLoaderService.stop();
                }
            );
        }
    }

    mapDbselect(dblookup: any, parentId: string) {
        const result = [];
        dblookup.forEach((array) => {
            const parentItem = {
                databaseSelectId:
                    array.databaseSelectId == null || array.databaseSelectId == '' || array.databaseSelectId == undefined
                        ? array.databaseSelectValueId
                        : array.databaseSelectId,
                name: array.name,
                displayName: array.displayName,
                values: [],
                editedDate: array.editedDate,
                parentId: array.parentId == undefined || array.parentId == '' || array.parentId == null ? 0 : array.parentId,
            };
            result.push(parentItem);

            if (array.values && array.values.length > 0) {
                const childItems = array.values.map((child) => ({
                    databaseSelectId: child.databaseSelectValueId,
                    name: child.name,
                    displayName: child.name,
                    values: [],
                    editedDate: array.editedDate,
                    parentId: array.databaseSelectId,
                }));
                result.push(...childItems);
            }
        });

        this.dbLookUpItemsNew = result;
    }

    onAddRow(data: any, treeListInstance: any) {
        treeListInstance.addRow();
    }

    getParentId(databaseSelectId: string) {
        return this.dbLookUpItems.filter((x) => x.databaseSelectId == databaseSelectId);
    }

    // * api call to get the material alias types

    createMaterialAliasTypesList() {
        const list = [];
        let i = 1;
        this.materialAliasTypes.forEach((array) => {
            const parentItem = {
                name: array.name,
                materialAliasId: array.materialTypeId,
                materialId: null,
                materialType: null,
                alias: null,
                active: false,
                allowed: true,
                parent: 0,
                parentId: 0,
                parentAliasName: array.name,
            };
            list.push(parentItem);
            i++;
        });
        this.materialAliasTypesList = list;
    }

    getMaterialAliasTypes(): void {
        const instanceId = localStorage.getItem('currentInstanceId');
        if (instanceId) {
            this.ngxUiLoaderService.start();
            this.idmApiService.getMaterialAliasTypes(instanceId).subscribe(
                (result) => {
                    this.ngxUiLoaderService.stop();
                    if (result.success) {
                        this.materialAliasTypes = result.response;
                    } else if (result.isCustom) {
                        this.userUtilityService.errorModelPopup(result.message);
                    }
                },
                (err) => this.ngxUiLoaderService.stop()
            );
        }
    }

    // * api call to get the material alias list
    getMaterialAliasListById(): void {
        const instanceId = localStorage.getItem('currentInstanceId');
        if (instanceId) {
            this.ngxUiLoaderService.start();
            this.idmApiService.getMaterialAliasById(instanceId).subscribe(
                (result) => {
                    this.ngxUiLoaderService.stop();
                    if (result.success) {
                        this.materialAliasList = result.response;
                        this.mapMaterialAliasList(result.response);

                        setTimeout(() => {
                            this.disableEditMaterialAlias = true;
                            this.disableCancelMaterialAlias = true;
                            this.cd.detectChanges();
                        }, 500);
                    } else if (result.isCustom) {
                        this.userUtilityService.errorModelPopup(result.message);
                    }
                    this.cd.detectChanges();
                },
                (err) => this.ngxUiLoaderService.stop()
            );
        }
    }

    getParent(type: MaterialTypeModel) {
        return type.name;
    }

    mapMaterialAliasList(list: any) {
        this.materialAliasTypesList = [];
        this.createMaterialAliasTypesList();

        list.forEach((array) => {
            const parentItem = {
                name: '',
                materialAliasId: array.materialAliasId,
                materialId: array.materialId,
                materialType: array.materialType,
                alias: array.alias,
                active: array.active,
                allowed: array.allowed,
                parent: this.getParent(array.materialType),
                parentAliasName: null,
                parentId: this.getParentI(array.materialType),
                qualifiedName: array.material,
            };
            this.materialAliasTypesList.push(parentItem);
        });

        // this.materialAliasTypesList.forEach((x) => {
        //     if (x && x.materialType && x.materialType?.materialType) {
        //         x.qualifiedName = this.findQualifiedName(x.materialType?.materialType, x?.materialId);
        //     }
        // });
    }

    // getQualifiedName(x: any) {
    //     if (x && x.materialType && x.materialType?.materialType) {
    //         return (x.qualifiedName = this.findQualifiedName(x.materialType?.materialType, x?.materialId));
    //     }
    // }

    getName(type: MaterialTypeModel) {
        return type.name;
    }
    getParentI(type: MaterialTypeModel) {
        return type.materialTypeId;
    }

    // * api call to get the gasket types
    getGasketTypes() {
        this.iceApiService.getGasketTypesForMaterialAlias().subscribe((res) => {
            this.gasketTypesList = res.response;
        });
    }

    // * helper methods for selecting a materials
    selectMaterial(materialAlias: MaterialAliasModel, index: number): void {
        const materialAliasFormArray = this.form.get('materialAlias') as UntypedFormArray;
        const dialogRef = this.ngbModal.open(MaterialListComponent, {
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
        });
        const currentFormGroup = materialAliasFormArray.controls[index];

        switch (materialAlias.materialType.materialType) {
            case 58:
                dialogRef.componentInstance.boltMaterialList = this.boltMaterialList;
                dialogRef.componentInstance.materialAlias = materialAlias;
                dialogRef.componentInstance.initData();
                dialogRef.result
                    .then((res: BoltMaterialModel) => {
                        if (res) {
                            currentFormGroup.get('qualifiedName').setValue(res.qualifiedName);
                            currentFormGroup.get('materialId').setValue(res.boltMaterialId);
                            currentFormGroup.markAsDirty();
                        }
                    })
                    .catch((e) => {
                        console.warn(e);
                    });
                break;

            case 67:
                dialogRef.componentInstance.materialAlias = materialAlias;
                dialogRef.componentInstance.flangeMaterialList = this.flangeMaterialList;
                dialogRef.componentInstance.initData();
                dialogRef.result
                    .then((res: FlangeMaterialModel) => {
                        if (res) {
                            currentFormGroup.get('qualifiedName').setValue(res.qualifiedName);
                            currentFormGroup.get('materialId').setValue(res.flangeMaterialId);
                            currentFormGroup.markAsDirty();
                        }
                    })
                    .catch((e) => {
                        console.warn(e);
                    });
                break;

            case 68:
                dialogRef.componentInstance.materialAlias = materialAlias;
                dialogRef.componentInstance.gasketList = this.gasketsList;
                dialogRef.componentInstance.gasketTypeList = this.gasketTypesList;
                dialogRef.componentInstance.initData();
                dialogRef.result
                    .then((result: GasketModel) => {
                        if (result) {
                            currentFormGroup.get('qualifiedName').setValue(result.qualifiedName);
                            currentFormGroup.get('materialId').setValue(result.gasketId);
                            currentFormGroup.markAsDirty();
                        }
                    })
                    .catch((e) => {
                        console.warn(e);
                    });
                break;
        }
    }

    // * helper to add the material aliases
    addMaterialAlias(): void {
        const materialAliasFormArray = this.form.get('materialAlias') as UntypedFormArray;
        const formGroup = new UntypedFormGroup({
            active: new UntypedFormControl(false, []),
            key: new UntypedFormControl(this.materialAliasList.length + 1, []),
            alias: new UntypedFormControl(' ', [Validators.required]),
            materialAliasId: new UntypedFormControl('', []),
            materialId: new UntypedFormControl('', [Validators.required]),
            qualifiedName: new UntypedFormControl('', []),
            materialTypeId: new UntypedFormControl('', [Validators.required]),
        });
        materialAliasFormArray.push(formGroup);
        this.materialAliasList.push(new MaterialAliasModel());
    }

    // * helper method to handle component's operations
    componentHandler(index: number, payLoad?: DbSelectLookUpModel[], materialALiasPayload?: MaterialAliasModel[]): void {
        /**
         * * case --- operation
         * * 1    --> dbLook up field deletion flow
         * * 2    --> material alias delete flow
         * * 3    --> check dbLookUps form state
         * * 4    --> check material alias form state
         * * 5    --> remove form controls after delete db look ups
         * * 6    --> remove form controls after delete material alias
         * * 7    --> generate db look ups api payload
         * * 8    --> generate material alias api payload
         * * 9    --> handle material alias form validation
         */
        const form = this.form.get('dbLookUpMaterialAlias') as UntypedFormArray;
        const materialAliasFormArray = this.form.get('materialAlias') as UntypedFormArray;
        switch (index) {
            case 1:
                let result: DbSelectLookUpModel[] = [];
                // const form = this.form.get('dbLookUpMaterialAlias') as FormArray;
                const tempFormArrayList = form.controls.slice();
                tempFormArrayList.forEach((control, mainIndex) => {
                    const currentLookUpIndex = this.dbLookUpItems.findIndex(
                        (item) => item.name.toLowerCase().trim() == control.value.name.toLowerCase().trim()
                    );
                    const dbLookUpItem: DbSelectLookUpModel = JSON.parse(JSON.stringify(control.value));
                    dbLookUpItem.values = [];
                    const subFormArray = control.get('values') as UntypedFormArray;
                    const subFormArrayCopy = subFormArray.controls.slice();
                    let isAllSelected = subFormArray.controls.every((subForm) => subForm.get('isSelected').value == true);
                    let isSomeSelected = subFormArray.controls.some((subForm) => subForm.get('isSelected').value == true);

                    if (isAllSelected) {
                        dbLookUpItem.active = false;
                        if (dbLookUpItem?.databaseSelectId) {
                            result = [...result, dbLookUpItem];
                        } else {
                            const itemIndex = this.dbLookUpItems.findIndex((item) => item.name.toLowerCase().trim() === control.value.name);
                            this.dbLookUpItems.splice(itemIndex, 1);
                            form.removeAt(itemIndex);
                        }
                    } else if (isSomeSelected) {
                        subFormArrayCopy.forEach((subControl, index) => {
                            if (subControl.get('isSelected').value) {
                                // delete subControl.value.name;
                                // delete subControl.value.isSelected;
                                const dbLookUpValue = new DbSelectLookUpValue();
                                dbLookUpValue.active = false;
                                dbLookUpValue.databaseSelectValueId = subControl.value.databaseSelectValueId;

                                if (!subControl.value?.databaseSelectValueId) {
                                    let formControlIndex = subFormArray.controls.findIndex(
                                        (item) => item.value.name.toLowerCase().trim() === subControl.value.name.toLowerCase().trim()
                                    );
                                    subFormArray.removeAt(formControlIndex);
                                    this.dbLookUpItems[currentLookUpIndex].values.splice(formControlIndex, 1);
                                } else {
                                    dbLookUpItem.values = [...dbLookUpItem.values, dbLookUpValue];
                                    dbLookUpItem.values[dbLookUpItem.values.length - 1].active = false;
                                    result = [...result, dbLookUpItem];
                                }
                            }
                        });
                    }
                });
                if (result.length > 0) {
                    this.saveLookUpFieldChanges(true, [...new Set(result)]);
                } else {
                    this.customToastService.successToast('Db Look Up deleted successfully!');
                    this.componentHandler(3, null, null); // * updating form State
                }
                this.cd.markForCheck();
                break;

            case 2:
                // const materialAliasFormArray = this.form.get('materialAlias') as FormArray;
                let materialAliasToBeDelete = [];
                let tempControls = [];
                let tempMaterialAlias = [];

                materialAliasFormArray.controls.slice().forEach((control, index) => {
                    if (control.value?.active) {
                        // if(control.value?.materialAliasId){
                        tempControls = [...tempControls, control];
                        tempMaterialAlias = [...tempMaterialAlias, this.materialAliasList[index]];
                        // }
                    }
                });

                tempControls.slice().forEach((control: UntypedFormControl) => {
                    let controlIndex = materialAliasFormArray.controls.slice().findIndex((mainControl) => mainControl.value.key === control.value.key);
                    if (controlIndex !== -1) {
                        if (control.value?.materialAliasId) {
                            materialAliasToBeDelete = [
                                ...materialAliasToBeDelete,
                                {
                                    materialAliasId: control.value.materialAliasId,
                                    active: false,
                                },
                            ];
                        } else {
                            materialAliasFormArray.removeAt(controlIndex);
                            this.materialAliasList.splice(controlIndex, 1);
                        }
                    }
                });

                if (materialAliasToBeDelete.length > 0) {
                    this.saveMaterialAliasChanges(true, materialAliasToBeDelete);
                } else {
                    // TODO toast
                    this.customToastService.successToast('Material Alias deleted successfully!');
                    const checkDirtyState = materialAliasFormArray.controls.every((control) => control.dirty == false);
                    if (checkDirtyState) {
                        this.form.get('materialAlias').reset(materialAliasFormArray.value);
                    }
                }
                break;

            case 3:
                let formStateArray = [];
                form.controls.forEach((mainControl) => {
                    const subForm = mainControl.get('values') as UntypedFormArray;
                    const formState = subForm.controls.every((item) => item.dirty == false);
                    formStateArray = [...formStateArray, formState];
                });

                if (formStateArray.every((item) => item == true)) {
                    form.reset(form.value);
                }
                break;

            case 4:
                const checkDirtyState = materialAliasFormArray.controls.every((control) => control.dirty == false);
                if (checkDirtyState) {
                    this.form.get('materialAlias').reset(materialAliasFormArray.value);
                }
                break;

            case 5:
                // const form = this.form.get('dbLookUpMaterialAlias') as FormArray;
                if (payLoad?.length) {
                    payLoad?.forEach((item) => {
                        let mainItemIndex = this.dbLookUpItems.findIndex((dbItem) => dbItem.databaseSelectId == item.databaseSelectId);
                        if (mainItemIndex !== -1) {
                            if (item.active == false) {
                                // * removing main form directly if parent is marked as false
                                this.dbLookUpItems.splice(mainItemIndex, 1);
                                form.removeAt(mainItemIndex);
                            } else {
                                const valuesFormArray = form.controls[mainItemIndex].get('values') as UntypedFormArray;
                                item.values.forEach((value) => {
                                    const targetControlIndex = valuesFormArray.controls.findIndex(
                                        (subControl) => subControl.value.databaseSelectValueId === value.databaseSelectValueId
                                    );
                                    if (targetControlIndex !== -1) {
                                        let valueIndex = this.dbLookUpItems[mainItemIndex].values.findIndex(
                                            (itemValue) => itemValue.databaseSelectValueId == value.databaseSelectValueId
                                        );
                                        this.dbLookUpItems[mainItemIndex].values.splice(valueIndex, 1);
                                        valuesFormArray.removeAt(targetControlIndex);
                                    }
                                });
                            }
                        }
                    });
                }

                break;

            case 6:
                if (materialALiasPayload?.length) {
                    materialALiasPayload?.forEach((item) => {
                        const controlIndex = materialAliasFormArray.controls.findIndex((control) => control.value.materialAliasId == item.materialAliasId);
                        if (controlIndex !== -1) {
                            materialAliasFormArray.removeAt(controlIndex);
                            this.materialAliasList.splice(controlIndex, 1);
                        }
                    });
                }
                break;

            case 7:
                form.controls.forEach((control) => {
                    if (control.get('name').dirty) {
                        const dbLookUpItem: DbSelectLookUpModel = control.value;
                        dbLookUpItem.values.length = 0;
                        const subForm = control.get('values') as UntypedFormArray;
                        subForm.controls.forEach((subControl) => {
                            if (subControl.get('name').dirty) {
                                delete subControl.value.isSelected;
                                dbLookUpItem.values = [...dbLookUpItem.values, subControl.value];
                            }
                        });
                        this.dbLookUpApiPayload = [...this.dbLookUpApiPayload, dbLookUpItem];
                    }
                });
                break;

            case 8:
                materialAliasFormArray.controls.forEach((formControl) => {
                    if (formControl.dirty) {
                        const formValue = JSON.parse(JSON.stringify(formControl.value));
                        delete formValue.qualifiedName;
                        delete formValue.active;
                        delete formValue.key;
                        this.materialAliasApiPayload = [...this.materialAliasApiPayload, formValue];
                    }
                });
                break;

            case 9:
                materialAliasFormArray.controls.forEach((control, index) => {
                    if (control.value.materialId) {
                        let checkSameMaterialIdExist = materialAliasFormArray.controls.filter(
                            (materialAlias, ind) => materialAlias.value.materialId === control.value.materialId && index != ind
                        );
                        let aliasList = checkSameMaterialIdExist.map((materialAlias) =>
                            materialAlias.value.alias ? materialAlias.value.alias.toLowerCase().trim() : ''
                        );
                        if (control.value.alias) {
                            if (aliasList.includes(control.value.alias.toLowerCase().trim())) {
                                control.get('alias').setErrors({
                                    duplicateName: true,
                                });
                            } else {
                                control.get('alias').setErrors(null);
                            }
                        }
                    }
                });
                break;
        }
    }

    // * enable/disable handler for delete button
    enableDisableDeleteButton(index: number): boolean {
        if (index == 1) {
            const materialAliasFormArray = this.form.get('materialAlias') as UntypedFormArray;
            const check = materialAliasFormArray.controls.some((control) => control.value.active == true);
            return !check;
        } else {
            const lookUpFormArray = this.form.get('dbLookUpMaterialAlias') as UntypedFormArray;
            let result = [];
            lookUpFormArray.controls.forEach((control) => {
                const subFormArray = control.get('values') as UntypedFormArray;
                subFormArray.controls.forEach((subCOntrol) => {
                    result = [...result, subCOntrol.value.isSelected];
                });
            });
            return !result.some((item) => item == true);
        }
    }

    onSelectionChanged(event: any) {
        const selectedRows = event.component.getSelectedRowsData();
        this.selectedDbLookUpItems = selectedRows;
        //  this.disableEdit = this.selectedDbLookUpItems && this.selectedDbLookUpItems.length == 1 ? false : true;
    }

    initNewRow(e: any) {
        e.data.parentId = e.data.parentId ? e.data.parentId : 0;
        //   e.data.name = 'Add new key';
        this.disableEdit = false;
        this.disableCancel = false;
    }

    // onRowRemoved(e: any) {
    //     console.log('onRowRemoved');
    //     console.log(e);
    // }

    // handleRowRemoving(e: any) {
    //     console.log('handleRowRemoving');
    //     console.log(e);
    // }

    handleRowRemoving(e: any) {
        // console.log('Row is about to be removed:', e.data);
        // // Example: Show confirmation dialog before deleting
        // const confirmDelete = confirm(`Are you sure you want to delete row with ID: ${e.data.id}?`);
        // if (!confirmDelete) {
        //     e.cancel = true; // Cancel the deletion if the user rejects
        // }
        // console.log('handleRowRemoving');
        // console.log(e);
    }

    onRowRemoved(e: any) {
        // console.log('onRowRemoved');
        // console.log(e);
    }

    onRowInserted(e: any) {
        if (e.data) {
            const data = e.data;
        }
    }

    onRowUpdated(e: any) {
        if (e.data) {
            const data = e.data;
            this.isDbSelectUpdating = true;
        }
    }

    handledeleteRow(e: any) {
        if (e.data) {
            const data = e.data;
        }
        // console.log('handledeleteRow');
        // console.log(e);
    }

    handleundeleteRow(e: any) {
        if (e.data) {
            const data = e.data;
        }
        // console.log('handleundeleteRow');
        // console.log(e);
    }

    customizeToolbar(e: any) {
        e.toolbarOptions.items = [];
    }

    addNewRow() {
        if (this.treeList) {
            this.treeList.instance.addRow();
        }
    }

    allowAdding = (e) => {
        return e.row.data.parentId == 0 && this.isDbLookUpAdd;
    };
    allowAdding2 = (e) => {
        return e.row.data.parentId == 0 && this.isMaterialAliasAdd;
    };

    allowDelete = (e) => {
        return e.row.data.parentId == 0 ? false : true;
    };

    allowDelete2 = (e) => {
        return e.row.data.parentId != 0 && this.isMaterialAliasDelete;
    };

    saveAllChanges(e: any) {
        if (this.treeList) {
            this.treeList.instance.saveEditData();
        }
    }

    handleSaving(e: any) {
        this.finaldataForSave = [];
        const changes = e.changes;
        const addedRecords = changes.filter((change) => change.type === 'insert');
        const updatedRecords = changes.filter((change) => change.type === 'update');
        const removedRecords = changes.filter((change) => change.type === 'remove');

        let dataforSave: DbSelectLookUpModel[] = [];
        if (addedRecords && addedRecords.length > 0) {
            dataforSave.push(addedRecords);
        }
        if (updatedRecords && updatedRecords.length > 0) {
            dataforSave.push(updatedRecords);
        }

        if ((updatedRecords && updatedRecords.length > 0) || (addedRecords && addedRecords.length > 0)) {
            this.storeddataforSave = dataforSave;
            this.isDbSelectUpdating = true;
        }

        this.isMultipleActions = (addedRecords.length > 0 || updatedRecords.length > 0) && removedRecords.length > 0 ? true : false;

        if (removedRecords && removedRecords.length > 0) {
            this.delete(removedRecords);
        }

        if (((addedRecords && addedRecords.length > 0) || (updatedRecords && updatedRecords.length > 0)) && !this.isMultipleActions) {
            this.convertToValueList1(dataforSave);
        }
    }

    delete(deleteData: any) {
        let dellist: DbSelectLookUpModel[] = [];
        let displaychildrenDelete = false;
        if (deleteData && deleteData.length > 0) {
            deleteData.forEach((db) => {
                let isChildAdded: boolean = false;
                let delData = this.dbLookUpItemsNew.filter((x) => x.databaseSelectId == db.key);
                let a: DbSelectLookUpModel = new DbSelectLookUpModel();
                if (delData && delData[0].parentId == '0') {
                    a.name = delData[0].name;
                    a.active = false;
                    a.databaseSelectId = db.key;
                    a.values = [];
                    const child = this.dbLookUpItemsNew.filter((x) => x.parentId == db.key);
                    if (child && child.length > 0) {
                        child.forEach((c) => {
                            let c1: DbSelectLookUpValue = new DbSelectLookUpValue();
                            c1.databaseSelectValueId = c.databaseSelectId;
                            c1.active = false;
                            a.values.push(c1);
                            displaychildrenDelete = true;
                        });
                    }
                } else {
                    let c: DbSelectLookUpValue = new DbSelectLookUpValue();
                    c.databaseSelectValueId = db.key;
                    c.active = false;

                    const parent = this.dbLookUpItemsNew.filter((x) => x.databaseSelectId == delData[0]?.parentId);
                    let existingParent = dellist.find((x) => x.name === parent[0]?.name);
                    if (!existingParent) {
                        a.databaseSelectId = delData[0].parentId;
                        a.name = parent?.length > 0 ? parent[0].name : '';
                        a.values = [c];
                    } else {
                        existingParent.values.push(c);
                        isChildAdded = true;
                    }
                }
                if (!isChildAdded) {
                    dellist.push(a);
                }
            });
        }

        const dialogRef = this.ngbModal.open(DeleteDialogComponent, {
            size: 'sm',
            backdrop: 'static',
            keyboard: false,
        });

        dialogRef.componentInstance.modalMessage = displaychildrenDelete
            ? 'Are you sure you want to delete selected <strong>DB lookups with children?</strong>'
            : 'Are you sure you want to delete selected <strong>DB lookups</strong>?';
        dialogRef.result
            .then((res) => {
                if (res) {
                    this.createDataForDelete(dellist);
                } else {
                    this.undoAllChanges();
                    this.getDbSelectsByInstanceId();
                }
            })
            .catch((err) => {
                console.warn(err);
            });
    }

    createDataForDelete(deleteData: any) {
        this.saveLookUpFieldChanges(true, deleteData);
    }

    getChild(parentId: string) {
        return this.dbLookUpItemsNew.filter((x) => x.databaseSelectId == parentId);
    }

    converttovaluelist(dataforSave: any, isDelete: boolean = false) {
        if (dataforSave && dataforSave.length > 0) {
            dataforSave[0].forEach((x) => {
                if (x) {
                    if (x.name) {
                        this.isValidData = this.customValidator.validateSqlInjectionforDevExpress(x.name);
                        if (!this.isValidData) {
                            this.customToastService.errorToast('Alias contains invalid characters.');
                        }
                    }

                    if (x.data.parentId) {
                        let child: DbSelectLookUpValue = new DbSelectLookUpValue();
                        child.name = x.data.name;
                        const parent = this.getChild(x.data.parentId);

                        if (this.finaldataForSave && this.finaldataForSave.length > 0) {
                            const p = this.finaldataForSave.filter((x) => x.name == parent[0].name);
                            if (p && p.length > 0) {
                                p[0].values.push(child);
                            } else {
                                if (parent && parent.length > 0) {
                                    parent[0].values = [child];
                                }
                                this.finaldataForSave.push(parent[0]);
                            }
                        } else {
                            if (parent && parent.length > 0) {
                                parent[0].values = [child];
                            }
                            this.finaldataForSave.push(parent[0]);
                        }
                    } else if (x.type === 'insert') {
                        let a: DbSelectLookUpModel = new DbSelectLookUpModel();
                        a.name = x.data.name;
                        a.values = [];
                        this.finaldataForSave.push(a);
                    } else if (this.isDbSelectUpdating) {
                        const selectnode = this.dbLookUpItemsNew.filter((f) => f.databaseSelectId == x.key);
                        if (selectnode && selectnode.length > 0 && selectnode[0].parentId == '0') {
                            let a: DbSelectLookUpModel = new DbSelectLookUpModel();
                            a.name = x.data.name;
                            a.databaseSelectId = x.key;
                            a.values = [];
                            this.finaldataForSave.push(a);
                        } else {
                            const parent = this.finaldataForSave.filter((x) => x.databaseSelectId == selectnode[0]?.parentId);
                            if (parent && parent.length > 0) {
                                let child: DbSelectLookUpValue = new DbSelectLookUpValue();
                                child.name = x.data.name;
                                child.databaseSelectValueId = x.key;
                                parent[0].values.push(child);
                            }
                        }
                        this.isDbSelectUpdating = false;
                    } else {
                        let a: DbSelectLookUpModel = new DbSelectLookUpModel();
                        a.name = x.data.name;
                        a.values = [];
                        this.finaldataForSave.push(a);
                    }
                }
            });
        }

        if (isDelete) {
            this.delete(this.finaldataForSave);
        } else {
            this.saveLookUpFieldChanges(true, this.finaldataForSave);
            this.disableEdit = false;
            this.disableCancel = false;
        }
    }

    convertToValueList1(dataForSave: any, isDelete: boolean = false) {
        if (!dataForSave || dataForSave.length === 0) return;

        this.finaldataForSave = [];

        const allChanges = dataForSave.flat();

        allChanges.forEach((change) => {
            if (!change?.data) return;

            // 1️⃣ Validate name for SQL injection
            if (change.data.name && !this.customValidator.validateSqlInjectionforDevExpress(change.data.name)) {
                this.customToastService.errorToast('Alias contains invalid characters.');
                return;
            }

            // 2️⃣ Handle Delete scenario separately
            if (isDelete) {
                this.handleDelete(change);
                return;
            }

            // 3️⃣ Handle Insert or Update
            if (change.type === 'insert') {
                this.handleInsert(change);
            } else if (change.type === 'update') {
                this.handleUpdate(change);
            }
        });

        if (isDelete) {
            this.delete(this.finaldataForSave);
        } else {
            this.saveLookUpFieldChanges(true, this.finaldataForSave);
            this.disableEdit = false;
            this.disableCancel = false;
        }
    }

    private handleInsert(change: any) {
        const { data } = change;

        if (data.parentId) {
            const parent = this.getParentById(data.parentId);
            if (!parent) return;

            const child = new DbSelectLookUpValue();
            child.name = data.name;

            let existingParent = this.finaldataForSave.find((p) => p.databaseSelectId === data.parentId || p.name === parent.name);

            if (!existingParent) {
                parent.values = [child];
                this.finaldataForSave.push(parent);
            } else {
                existingParent.values.push(child);
            }
        } else {
            const parent = new DbSelectLookUpModel();
            parent.name = data.name;
            parent.values = [];
            this.finaldataForSave.push(parent);
        }
    }

    private handleUpdate(change: any) {
        const { data, key } = change;
        const node = this.dbLookUpItemsNew.find((n) => n.databaseSelectId === key);
        if (!node) return;

        if (node.parentId === '0') {
            const parent = new DbSelectLookUpModel();
            parent.name = data.name;
            parent.databaseSelectId = key;
            parent.values = [];
            this.finaldataForSave.push(parent);
        } else {
            const parent = this.finaldataForSave.find((p) => p.databaseSelectId === node.parentId);
            const child = new DbSelectLookUpValue();
            child.name = data.name;
            child.databaseSelectValueId = key;

            if (parent) {
                parent.values.push(child);
            } else {
                const parentNode = this.getParentById(node.parentId);
                if (parentNode) {
                    parentNode.values = [child];
                    this.finaldataForSave.push(parentNode);
                }
            }
        }
    }

    private handleDelete(change: any) {
        const { data } = change;
        const parent = this.getParentById(data.parentId || data.databaseSelectId);
        if (parent) this.finaldataForSave.push(parent);
    }

    private getParentById(parentId: string): DbSelectLookUpModel | null {
        const parentList = this.dbLookUpItemsNew.filter((p) => p.databaseSelectId === parentId);
        return parentList && parentList.length > 0 ? { ...parentList[0], values: [] } : null;
    }

    undoAllChanges() {
        if (this.treeList) {
            this.treeList.instance.cancelEditData();
        }
        this.disableEdit = true;
        this.disableCancel = true;
    }

    trackEditedCell(e: any) {
        const rowKey = e.key; // The row key of the edited cell
        const dataField = e.column.dataField; // The data field (column) of the edited cell

        // Track edited cells using a map
        if (!this.editedCells[rowKey]) {
            this.editedCells[rowKey] = new Set<string>();
        }
        this.editedCells[rowKey].add(dataField);
    }

    handleCellPrepared(e: any) {
        if (e.cellElement) {
            e.cellElement.classList.remove('dx-cell-modified');
        }
        if (e.rowType === 'data' && e.column.dataField) {
            const rowKey = e.key;
            const dataField = e.column.dataField;
            // Check if this cell has been edited
            if (this.editedCells[rowKey] && this.editedCells[rowKey].has(dataField)) {
                e.cellElement.style.backgroundColor = 'green'; // Apply custom background color
                e.cellElement.style.color = 'red'; // Apply custom background color
            }
        }
    }
    materialAliasCellPrepared(e: any) {
        if (e.cellElement) {
            e.cellElement.classList.remove('dx-cell-modified');
        }
        if (e.rowType === 'data' && e.column.dataField) {
            const rowKey = e.key;
            const dataField = e.column.dataField;
            // Check if this cell has been edited
            if (this.editedCells[rowKey] && this.editedCells[rowKey].has(dataField)) {
                e.cellElement.style.backgroundColor = 'green'; // Apply custom background color
                e.cellElement.style.color = 'red'; // Apply custom background color
            }
            // if (!e.data.allowed && e.data.parentId != 0) {
            //     e.cellElement.classList.add('dx-state-disabled');
            //     e.cellElement.style.pointerEvents = 'none'; // disable click
            // }
        }
    }
    handleRowPrepared(e: any) {
        if (e.rowType === 'data') {
            const hasChildren = this.hasChildren(e.key);
            if (hasChildren) {
                const hrElement = document.createElement('hr');
                e.rowElement.appendChild(hrElement);
            }
        }
    }
    materialAliashandleRowPrepared(e: any) {
        if (e.rowType === 'data') {
            const hasChildren = this.hasChildren(e.key);
            if (hasChildren) {
                const hrElement = document.createElement('hr');
                e.rowElement.appendChild(hrElement);
            }
            if (!e.data.allowed && e.data.parentId != 0) {
                e.rowElement.classList.add('dx-state-disabled');
                e.rowElement.style.pointerEvents = 'none'; // disable click
            }
        }
    }

    hasChildren(rowKey: any): boolean {
        // Check if the current row has children based on the rowKey
        //  const childRows = this.data.filter(item => item.parentId === rowKey);
        //   return childRows.length > 0;
        return true;
    }

    handlePropertyChange(e: any) {
        this.disableEdit = false;
        this.disableCancel = false;
    }

    handleMaterialAliasPropertyChange(e: any) {
        this.disableCancelMaterialAlias = false;
        this.disableEditMaterialAlias = false;
    }

    displayName = (rowData: any) => {
        return rowData.parentId == 0 ? rowData.name : null;
    };
    displayName2 = (rowData: any) => {
        return rowData.parentId == 0 ? rowData.name : rowData.qualifiedName;
    };
    onCellClick(cellData: any): void {
        if (cellData.data.parentId != 0 && cellData.column.dataField == 'qualifiedName') {
            this.selectMaterialAliasPopup(cellData.data, cellData.rowIndex);
        }

        if (cellData.data.parentId != 0 && cellData.column.dataField == 'alias') {
            cellData.data.alias = cellData.data.alias == 'Enter alias' ? '' : cellData.data.alias;
        } else if (cellData.data.parentId == 0 && cellData.column.dataField == 'alias') {
            cellData.data.alias = '';
        } else if (cellData.column.dataField == 'alias') {
            cellData.data.alias = cellData.data.alias == 'Enter alias' || cellData.data.alias == '' ? 'Enter alias' : cellData.data.alias;
        }

        this.cd.detectChanges();
    }

    selectMaterialAliasPopup(materialAlias: MaterialAliasModel, index: number) {
        this.materialAlias = materialAlias;
        const type = this.materialAliasTypes.filter((x) => x.materialTypeId == materialAlias.parentId);
        materialAlias.materialType = type[0];
        this.cd.detectChanges();
        const dialogRef = this.ngbModal.open(MaterialListComponent, {
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
        });

        switch (materialAlias?.materialType?.materialType || (type && type[0].materialType)) {
            case 58:
                dialogRef.componentInstance.boltMaterialList = this.boltMaterialList;
                dialogRef.componentInstance.materialAlias = materialAlias;
                dialogRef.componentInstance.initData();
                dialogRef.result
                    .then((res) => {})
                    .catch((err) => {
                        console.warn('Modal dismissed:', err);
                    });

                break;

            case 67:
                dialogRef.componentInstance.materialAlias = materialAlias;
                dialogRef.componentInstance.flangeMaterialList = this.flangeMaterialList;
                dialogRef.componentInstance.initData();
                dialogRef.result
                    .then((res) => {})
                    .catch((err) => {
                        console.warn(err);
                    });

                break;

            case 68:
                dialogRef.componentInstance.materialAlias = materialAlias;
                dialogRef.componentInstance.gasketList = this.gasketsList;
                dialogRef.componentInstance.gasketTypeList = this.gasketTypesList;
                dialogRef.componentInstance.initData();
                dialogRef.result
                    .then((res: GasketModel) => {
                        if (res) {
                            if (materialAlias && materialAlias?.materialId != res.gasketId) {
                                this.isMaterialChanged = true;
                            }
                            if (materialAlias.materialId && materialAlias.alias != '') {
                                materialAlias.materialId = res.gasketId;
                                materialAlias.qualifiedName = res.qualifiedName;
                            } else {
                                materialAlias.materialId = res.gasketId;
                                materialAlias.qualifiedName = res.qualifiedName;
                                this.cd.detectChanges();

                                return materialAlias;
                            }

                            if (this.isMaterialChanged) {
                                let array: MaterialAliasModel = new MaterialAliasModel();
                                array.alias = materialAlias.alias;
                                array.materialAliasId = materialAlias.materialAliasId;

                                array.materialId = materialAlias.materialId;
                                array.materialTypeId = materialAlias.materialType?.materialTypeId;

                                this.selectedMaterialAliasModel.push(array);
                            }
                        }
                    })
                    .catch((e) => {
                        console.warn(e);
                    });
                break;
        }
        this.cd.detectChanges();
        // console.log(materialAlias);
    }

    loadMaterialAlias(currentMaterialAlias: any) {
        console.log(currentMaterialAlias);
        const type = this.materialAliasTypes.filter((x) => x.materialTypeId == this.materialAlias.parentId);
        this.materialAlias.materialType = type[0];

        switch (this.materialAlias?.materialType?.materialType || (type && type[0].materialType)) {
            case 58:
                if (this.materialAlias && this.materialAlias?.materialId != currentMaterialAlias.boltMaterialId) {
                    this.isMaterialChanged = true;
                }

                if (this.materialAlias && this.materialAlias?.materialId && this.materialAlias?.alias != '') {
                    this.materialAlias.materialId = currentMaterialAlias.boltMaterialId;
                    this.materialAlias.qualifiedName = currentMaterialAlias.qualifiedName;
                } else {
                    this.materialAlias.materialId = currentMaterialAlias.boltMaterialId;
                    this.materialAlias.qualifiedName = currentMaterialAlias.qualifiedName;
                    this.treeList2.instance.refresh();
                    return this.materialAlias;
                }

                if (this.isMaterialChanged) {
                    let array: MaterialAliasModel = new MaterialAliasModel();
                    array.alias = this.materialAlias.alias;
                    array.materialAliasId = this.materialAlias.materialAliasId;

                    array.materialId = this.materialAlias.materialId;
                    array.materialTypeId = this.materialAlias.materialType?.materialTypeId;
                    this.selectedMaterialAliasModel.push(array);
                }
                this.cd.detectChanges();

                break;

            case 67:
                if (this.materialAlias && this.materialAlias?.materialId != currentMaterialAlias.flangeMaterialId) {
                    this.isMaterialChanged = true;
                }

                if (this.materialAlias.materialId && this.materialAlias.alias != '') {
                    this.materialAlias.materialId = currentMaterialAlias.flangeMaterialId;
                    this.materialAlias.qualifiedName = currentMaterialAlias.qualifiedName;
                } else {
                    this.materialAlias.materialId = currentMaterialAlias.flangeMaterialId;
                    this.materialAlias.qualifiedName = currentMaterialAlias.qualifiedName;
                }

                if (this.isMaterialChanged) {
                    let array: MaterialAliasModel = new MaterialAliasModel();
                    array.alias = this.materialAlias.alias;
                    array.materialAliasId = this.materialAlias.materialAliasId;

                    array.materialId = this.materialAlias.materialId;
                    array.materialTypeId = this.materialAlias.materialType?.materialTypeId;

                    this.selectedMaterialAliasModel.push(array);
                }
                this.cd.detectChanges();

                break;

            // case 68:
            //     if (this.materialAlias && this.materialAlias?.materialId != currentMaterialAlias.gasketId) {
            //         this.isMaterialChanged = true;
            //     }
            //     if (this.materialAlias.materialId && this.materialAlias.alias != '') {
            //         this.materialAlias.materialId = currentMaterialAlias.gasketId;
            //         this.materialAlias.qualifiedName = currentMaterialAlias.qualifiedName;
            //     } else {
            //         this.materialAlias.materialId = currentMaterialAlias.gasketId;
            //         this.materialAlias.qualifiedName = currentMaterialAlias.qualifiedName;
            //         this.cd.detectChanges();

            //         return this.materialAlias;
            //     }

            //     if (this.isMaterialChanged) {
            //         let array: MaterialAliasModel = new MaterialAliasModel();
            //         array.alias = this.materialAlias.alias;
            //         array.materialAliasId = this.materialAlias.materialAliasId;

            //         array.materialId = this.materialAlias.materialId;
            //         array.materialTypeId = this.materialAlias.materialType?.materialTypeId;

            //         this.selectedMaterialAliasModel.push(array);
            //     }
            //     this.cd.detectChanges();
            //     break;
        }
    }

    saveMaterialAlies() {
        this.saveMaterialAliasChanges(false, this.finalMaterialAliasDataForSave);
    }

    // findQualifiedName(materialType: number, materialId: string) {
    //     if (materialType == 58) {
    //         if (!this.boltMaterialList.find((material) => material.boltMaterialId == materialId)?.qualifiedName) {
    //             var tt = 0;
    //         }
    //         return this.boltMaterialList.find((material) => material.boltMaterialId == materialId)?.qualifiedName;
    //     } else if (materialType == 67) {
    //         return this.flangeMaterialList.find((material) => material.flangeMaterialId == materialId).qualifiedName;
    //     } else if (materialType == 68) {
    //         return this.gasketsList.find((gasket) => gasket.gasketId == materialId).qualifiedName;
    //     }
    // }

    undoAllChangesMaterialAlias() {
        if (this.treeList2) {
            this.treeList2.instance.cancelEditData();
        }
        this.disableEditMaterialAlias = true;
        this.disableCancelMaterialAlias = true;
    }

    initMaterialAliasNewRow(e: any) {
        if (e.data.parentId == '06b0eebc-8e97-49fc-81b4-c11d419eb11a') {
            e.data.qualifiedName = 'Select Bolt Material';
        } else if (e.data.parentId == '23dd4641-3fbe-4d3f-ab8d-acf0e9a95cac') {
            e.data.qualifiedName = 'Select Flange Material';
        } else if (e.data.parentId == '6785518f-8b3c-4b1a-a901-fe608bd3ab97') {
            e.data.qualifiedName = 'Select Gasket';
        }

        e.data.parent = e.data.parent ? e.data.parent : 0;
        e.data.materialTypeId = e.data.parentId;
        e.data.allowed = true;
        e.data.alias = 'Enter alias';
        this.disableEditMaterialAlias = false;
        this.disableCancelMaterialAlias = false;
    }

    addMaterialAliasNew() {
        if (this.treeList2) {
            this.treeList2.instance.addRow();
        }
    }
    saveMaterialAliasAllChanges(e: any) {
        if (this.treeList2) {
            this.treeList2.instance.saveEditData();
        }
    }

    validate(e: any) {
        return e.alias == 'Enter alias' ||
            e.qualifiedName == 'Select Bolt Material' ||
            e.qualifiedName == 'Select Flange Material' ||
            e.qualifiedName == 'Select Gasket'
            ? false
            : true;
    }

    handleMaterialAliasSaving(e: any) {
        this.isMaterialAliasUpdating = false;
        if (!this.treeList2.instance.hasEditData()) {
            e.cancel = true;
        }

        this.finalMaterialAliasDataForSave = [];
        const changes = e.changes;
        const addedRecords = changes.filter((change) => change.type === 'insert');
        const updatedRecords = changes.filter((change) => change.type === 'update');
        const removedRecords = changes.filter((change) => change.type === 'remove');

        let dataforSave: MaterialAliasModel[] = [];
        if (addedRecords && addedRecords.length > 0) {
            dataforSave.push(addedRecords);
        }
        if (updatedRecords && updatedRecords.length > 0) {
            dataforSave.push(updatedRecords);
            this.isMaterialAliasUpdating = true;
        }

        if ((updatedRecords && updatedRecords.length > 0) || (addedRecords && addedRecords.length > 0)) {
            this.storeddataforSaveForMaterialAlias = dataforSave;
        }

        this.isMultipleActionsForMaterialAlias = (addedRecords.length > 0 || updatedRecords.length > 0) && removedRecords.length > 0 ? true : false;

        if (removedRecords && removedRecords.length > 0) {
            this.deleteMaterialAlias(removedRecords);
        }
        if (((addedRecords && addedRecords.length > 0) || (updatedRecords && updatedRecords.length > 0)) && !this.isMultipleActionsForMaterialAlias) {
            this.saveMaterialAlias(dataforSave);
        }

        if (this.isMaterialChanged && this.selectedMaterialAliasModel && this.selectedMaterialAliasModel.length > 0) {
            this.saveMaterialAlias(this.selectedMaterialAliasModel);
        }
    }

    saveMaterialAlias(sData: any, isUpdate: boolean = false) {
        if (sData && sData.length > 0 && sData[0] && sData[0].length > 0) {
            sData[0].forEach((x) => {
                let alias = x.data.alias;
                if (alias) {
                    this.isValidData = this.customValidator.validateSqlInjectionforDevExpress(alias);
                    if (!this.isValidData) {
                        this.customToastService.errorToast('Alias contains invalid characters.');
                    }
                }

                if (x.data.alias != 'Enter alias' && x.data.materialId) {
                    let array: MaterialAliasModel = new MaterialAliasModel();
                    array.alias = x.data.alias;
                    array.materialId = x.data.materialId;
                    array.materialAliasId = '';
                    array.materialTypeId = x.data.materialTypeId;
                    this.finalMaterialAliasDataForSave.push(array);
                    this.isError = false;
                } else if (x.data.alias == 'Enter alias') {
                    this.finalMaterialAliasDataForSave = [];
                    this.savedData = sData[0];
                    this.isError = true;
                    this.customToastService.errorToast('Please enter alias');
                } else if (this.isError && x.data.alias) {
                    this.savedData.forEach((y) => {
                        let array: MaterialAliasModel = new MaterialAliasModel();
                        array.alias = y.data.alias == 'Enter alias' ? alias : y.data.alias;
                        array.materialId = y.data.materialId;
                        array.materialAliasId = '';
                        array.materialTypeId = y.data.materialTypeId;
                        this.finalMaterialAliasDataForSave.push(array);
                    });
                    this.isError = false;
                }

                if (this.isMaterialAliasUpdating && x.key) {
                    let array: MaterialAliasModel = new MaterialAliasModel();
                    array.alias = alias;
                    array.materialAliasId = x.key;

                    const row = this.materialAliasTypesList.find((z) => z.materialAliasId == x.key);
                    array.materialId = row?.materialId;
                    array.materialTypeId = row?.materialType?.materialTypeId;

                    this.finalMaterialAliasDataForSave.push(array);
                }
            });
        }

        this.selectedMaterialAliasModel = this.selectedMaterialAliasModel.filter((x) => x.alias != 'Enter alias');
        if (this.isMaterialChanged && this.selectedMaterialAliasModel && this.selectedMaterialAliasModel.length > 0) {
            this.selectedMaterialAliasModel.forEach((x) => {
                let alias = x.alias;
                if (alias) {
                    this.isValidData = this.customValidator.validateSqlInjectionforDevExpress(alias);
                    if (!this.isValidData) {
                        this.customToastService.errorToast('Alias contains invalid characters.');
                    }
                }
                this.finalMaterialAliasDataForSave.push(x);
            });
        }

        if (this.finalMaterialAliasDataForSave && this.finalMaterialAliasDataForSave.length > 0 && this.isValidData) {
            this.saveMaterialAliasChanges(false, this.finalMaterialAliasDataForSave);

            this.isMaterialChanged = false;
            this.selectedMaterialAliasModel = [];
        }
    }

    deleteMaterialAlias(deleteData: any) {
        let dellist: MaterialAliasModel[] = [];
        if (deleteData && deleteData.length > 0) {
            deleteData.forEach((db) => {
                let delData = this.materialAliasTypesList.filter((x) => x.materialAliasId == db.key);
                let a: MaterialAliasModel = new MaterialAliasModel();
                if (delData && delData[0].parentId != '0') {
                    a.name = delData[0].name;
                    a.active = false;
                    a.materialAliasId = db.key;
                }
                dellist.push(a);
            });
        }

        const dialogRef = this.ngbModal.open(DeleteDialogComponent, {
            size: 'sm',
            backdrop: 'static',
            keyboard: false,
        });

        dialogRef.componentInstance.modalMessage = 'Are you sure you want to delete selected <strong>Material Alias</strong>?';

        dialogRef.result
            .then((res) => {
                if (res) {
                    this.saveMaterialAliasChanges(true, dellist);
                } else {
                    this.undoAllChangesMaterialAlias();
                    this.getMaterialAliasListById();
                }
            })
            .catch((err) => {
                console.warn(err);
            });
    }

    handleCellFocus(cellData: any) {}

    onValueChanged(e) {
        // console.log('Selected Value:', e.value);
        this.cd.detectChanges();
    }

    onEditorPreparingDBSelect(e: any) {
        if (e.parentType === 'dataRow' && e.editorName === 'dxTextBox') {
            e.editorOptions.onKeyDown = (event) => {
                const input = event.component?.element().querySelector('input');
                const result = this.customValidator.validateSqlInjectionforDevExpress(input?.value);
                if (!result) {
                    event.event.preventDefault();
                    this.customToastService.errorToast('Input contains invalid characters.');
                }
            };

            e.editorOptions.onInput = (event) => {
                const input = event.component?.element().querySelector('input');
                const result = this.customValidator.validateSqlInjectionforDevExpress(input?.value);

                if (!result) {
                    event.event.preventDefault();
                    this.customToastService.errorToast('Input contains invalid characters.');
                }
            };
        }
    }

    onEditorPreparing(e: any) {
        if (e.row.data && e.row.data.parentId === 0) {
            e.cancel = true; // Disable editing for parent rows
        }
        if (e.parentType === 'dataRow' && e.editorName === 'dxTextBox') {
            e.editorOptions.onKeyDown = (event) => {
                const input = event.component?.element().querySelector('input');
                const result = this.customValidator.validateSqlInjectionforDevExpress(input?.value);

                if (!result) {
                    event.event.preventDefault();
                    this.customToastService.errorToast('Input contains invalid characters.');
                }
            };

            e.editorOptions.onInput = (event) => {
                const input = event.component?.element().querySelector('input');
                const result = this.customValidator.validateSqlInjectionforDevExpress(input?.value);
                if (!result) {
                    event.event.preventDefault();
                    this.customToastService.errorToast('Input contains invalid characters.');
                }
            };
        }
    }

    onRowPrepared(e: any) {
        if (e.rowType === 'data' && e.data.parentId === 0) {
            e.rowElement.style.pointerEvents = 'none'; // Disable clicks
            e.rowElement.style.backgroundColor = '#f5f5f5'; // Optional: Grey out parent rows
        }
    }

    validateAlias(e: any) {
        return e.data.alias == 'Enter alias' ? false : true;
    }

    validateQualifiedName(e: any) {
        return e.data.qualifiedName == 'Select Bolt Material' || e.data.qualifiedName == 'Select Flange Material' || e.data.qualifiedName == 'Select Gasket'
            ? false
            : true;
    }

    aliasValidator = (e: any): boolean => {
        const value = e.value || '';
        return /^[a-zA-Z0-9_\-\s]*$/.test(value);
    };

    validateAliasInput = (e: any): void => {
        const key = e.event?.key;
        if (!key) return;
        const allowed = /^[a-zA-Z0-9_\-\s]*$/;
        if (!allowed.test(key)) {
            e.event.preventDefault();
            this.customToastService.errorToast('Input contains invalid characters.');
        }
    };

    validateAliasPaste = (e: any): void => {
        const inputElement = e.target as HTMLInputElement;
        const currentValue = inputElement.value;

        //   const a = e.event.currentTarget as HTMLInputElement;
        if (!/^[a-zA-Z0-9\s]*$/.test(currentValue)) {
            e.event.preventDefault(); // Block the paste
            this.customToastService.errorToast('Input contains invalid characters.');
        }
    };
}
